import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";
//获取软件包列表
export function getSoftwarePackageList(offset, limit) {
    const data = {
        user_id: getuser_id(),
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/softwarePackageManager/getSoftwarePackageList',
        method: 'post',
        data
    })
}
//上传软件包
export function addSoftwarePackage(file) {
    const data = {
        file: file,
        spId: 0
    }
    return http({
        url: '/api/softwarePackageManager/addSoftwarePackage',
        method: 'post',
        data
    })
}
//下载软件包

export function softwarePackageManager(spPath,spName,){
    return http({
        url:`/api/softwarePackageManager/download?downloadUrl=${spPath}&realFileName=${spName}`,
        method:'get'
    })
}

//删除软件包
export function delSoftwarePackage(id) {
    const data = {
        id: id
    }
    return http({
        url: '/api/softwarePackageManager/delSoftwarePackage',
        method: 'post',
        data
    })
}
//查询软件包
export function queryKeyword(keyword, offset, limit, sort) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        spName: sort.spName,
        spVersion: sort.spVersion,
        spType: sort.spType,
        spSize: sort.spSize,
        username: sort.username,
        spCreate: sort.spCreate,
        md5: sort.md5
    }
    return http({
        url: '/api/softwarePackageManager/queryKeyword',
        method: 'post',
        data
    })
}
//获取所有客户列表
//获取客户列表
export function getCustomerList() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 99999
    }
    return http({
        url: '/api/customer/getCustomerList',
        method: 'post',
        data
    })
}
//修改固件权限
export function updateSoftwarePackagePermission(spId, permission) {
    const data = {
        id: spId,
        permission: permission
    }
    return http({
        url: '/api/softwarePackageManager/updateSoftwarePackagePermission',
        method: 'post',
        data
    })
}

//查找所有正在备份的软件包

export function findSoftwarePackageBackuping() {
    return http({
        url: '/api/softwarePackageManager/findSoftwarePackageBackuping',
        method: 'get'
    })
}